module.exports = __webpack_public_path__ + "img/egomi.dfe9813.png";